type EmailNameFieldsProps = {
  email: string;
  name: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

export const EmailNameFields = ({ email, name, onChange }: EmailNameFieldsProps) => {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
      <div>
        <label
          htmlFor="email"
          className="block text-[16px] md:text-[17px] font-medium text-[#111827] mb-2"
        >
          Email <span className="text-red-500">*</span>
        </label>
        <input
          type="email"
          id="email"
          name="email"
          value={email}
          onChange={onChange}
          required
          className="w-full rounded-md border border-gray-300 px-3 py-2 text-[16px] text-[#111827] focus:border-[#026857] focus:outline-none focus:ring-2 focus:ring-[#026857]/20"
        />
      </div>
      <div>
        <label
          htmlFor="name"
          className="block text-[16px] md:text-[17px] font-medium text-[#111827] mb-2"
        >
          Full Name <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          id="name"
          name="name"
          value={name}
          onChange={onChange}
          required
          className="w-full rounded-md border border-gray-300 px-3 py-2 text-[16px] text-[#111827] focus:border-[#026857] focus:outline-none focus:ring-2 focus:ring-[#026857]/20"
        />
      </div>
    </div>
  );
};

